jQuery(document).ready(function($) {

    const breakpointLG = 991;
    const breakpointXL = 1199;

    // Main menu toggle
    $('#menu-toggle').on('click touchstart', function(event){

		$('body').toggleClass('main-menu-active');
        $(this).toggleClass('active');
        $('nav.menu--main > ul > li').removeClass('open');

        if ($(this).attr( 'aria-expanded') === 'true') {
            $(this).attr( 'aria-expanded', 'false');
        } else {
            $(this).attr( 'aria-expanded', 'true');
        }

        event.stopImmediatePropagation();
        event.preventDefault();
    });

    // Stores filter toggle
    $('#filter-toggle').on('click touchstart', function(event){

        $('body').toggleClass('stores-filter-open');
        $(this).toggleClass('filter-open');
        $('nav.menu--main > ul > li').removeClass('open');

        if ($(this).attr( 'aria-expanded') === 'true') {
            $(this).attr( 'aria-expanded', 'false');
        } else {
            $(this).attr( 'aria-expanded', 'true');
        }

        event.stopImmediatePropagation();
        event.preventDefault();
    });

    // Active states for category list page (old systemname = inspiration-page)
    if($('body').hasClass('page-node-type-inspiration-page')) {
      $('.map-utilities li.menu-item:last-child').addClass('menu-item--active-trail');

      var currentUri = window.location.pathname;
      if(currentUri.length > 0) {
        $('.view-id-categories.view-display-id-block_2 .views-row').each(function() {
          var ctaUri = $(this).find('.views-field-field-link-to-page a').attr('href');

          if(ctaUri === currentUri) {
            $(this).addClass('active');
          }
        });
      }
    }

    // Add results count to map-util-bar
    if($('.view-winkelkaart.view-display-id-block_1, .path-winkels .view-winkelkaart').length > 0) {
      $('.view-winkelkaart .view-results-count').prependTo(".map-utilities").addClass('show-it');
    }


    $('.field--name-field-gallery').slick({
        slidesToShow: 3,
        pauseOnHover: false,
        infinite: true,
        speed: 800,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    $('.field--name-field-stores-gallery').slick({
        slidesToShow: 3,
        pauseOnHover: false,
        infinite: true,
        speed: 800,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
            {
                breakpoint: breakpointXL,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    $('.instagram-feed').slick({
        slidesToShow: 5,
        pauseOnHover: false,
        infinite: true,
        speed: 10000,
        autoplaySpeed: 0,
        autoplay: true,
        arrows: false,
        cssEase: 'linear',
        swipe: false,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: breakpointLG,
                settings: {
                    slidesToShow: 2,
                }
            },
        ]
    });

    // Clickable cards
    $('.paragraph--type--field-stores .field--name-field-stores-gallery .slick-track > .field__item').on('click', function(e){
        window.location = $(this).find('.field--name-node-title a').attr('href');
    }).addClass('clickable');

    $('.view-events .views-row, ' +
      '.view-news .views-row').on('click', function(e){
        window.location = $(this).find('h3 a').attr('href');
    }).addClass('clickable');


    // Remove click from button
    $('.view-winkelkaart .views-row .field--name-node-link a').on('click', function(e) {
        e.preventDefault();
    });


    // Menu items
    if ($(window).width() < breakpointXL) {
        $('.menu--main ul.menu > .menu-item--expanded > a').on('click', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('submenu-open');
        });
    }
});

window.addEventListener('message', event => {

    if (event.origin != 'https://dashboard.scratchcard.shop') {

    return false;
    }

    document.getElementById("embed-form").style.height = event.data + 'px';
});

// Make whole card clickable
function clickableCard(element, link) {
    element.addEventListener('click', (e) => {
        window.open(link, '_self');
    })

    element.style.cursor = 'pointer';
    element.classList.add('clickable');
}
function handleElementLink(element) {
    const link = element.getElementsByTagName('A')[0];

    if (_.isNil(link)) {
        return;
    }

    clickableCard(element, link);
}

const teasers = document.querySelectorAll('.paragraph--type--teasers .view-card');

if (!_.isEmpty(teasers)) {
    Array.from(teasers).forEach(teaser => handleElementLink(teaser));
}